<template>
  <div class="flex-1 relative wrapper" @mouseleave="isShow = false">
    <div class="info" v-if="introduction" @mouseenter="isShow = true" >查看介绍</div>
    <slot :path="path" ></slot>
    <div @mouseenter="introduction ? isShow = true : ''"><slot name="footer"></slot></div>
    <div class="introduction inset-0 flex items-center" :class="{ 'active': isShow }" v-if="introduction" >
      <el-scrollbar :wrap-style="{
        maxHeight: `calc(${styles.height} - 20px)`
      }">
        <p class="introduction-content text-[15px] leading-5 px-4">{{ introduction }}</p>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    introduction: {
      type: String,
      default: ''
    },
    path:{
      type:String,
      default:''
    },
    styles: {
      type: Object,
      default: () => { },
    },
  },
  data(){
    return {
      isShow:false
    }
  },
};
</script>

<style lang="scss" scoped>
.introduction {
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  background: rgba(0, 0, 0, 0.8);
  transition: .2s all ease;
  top: 100%;
  opacity: 0;
}
.introduction-title {
  margin-top: 14px;
  margin-bottom: 10px;
  text-align: right;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.introduction-content {
  font-weight: 600;
  text-align: justify;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  white-space: pre-line;
  font-size: 13px;
}
.info {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  cursor: pointer;
  position: absolute;
  top: 0px;
  right: 0px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 75px;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  border-radius: 0 6px 0 6px;
  z-index: 1;
}
.active.introduction {
  top: 0;
  opacity: 1;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
